import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import  { environment } from '../../environments/environment'
const httpOptions = {
  headers: new HttpHeaders({
    'Authorization':  'Api-Key '+ environment.api_key
  })
};
@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(
    private http:HttpClient
  ) { }

  submitBooking(booking:any){
    return this.http.post(environment.bookingApi,booking,httpOptions);
  }

  getPaymentOptions(query: {
    amount: number;
    operator: string;
    leavingFrom: string;
    goingTo: string;
    currency: 'KSH' | 'UGX';
  }) {
    const params = new HttpParams()
      .set('amount', String(query.amount))
      .set('operator', query.operator)
      .set('leaving_from', query.leavingFrom)
      .set('going_to', query.goingTo)
      .set('currencies', query.currency)
      .set('version', '2');

    // Like every other endpoint in this app, the payload is wrapped in a
    // top-level `data` envelope - see e.g. res.data.initial_trip in
    // booking.component.ts.
    return this.http.get<{ data: { payment_options: Array<{
      payment_option: string;
      currency: 'KSH' | 'UGX';
      extra_charge: number;
    }> } }>(environment.paymentOptionsApi, { ...httpOptions, params });
  }

  // submitBooking(booking:any,operator:any){
  //   return this.http.post<any>(environment.bookingApi,booking,httpOptions);
  // }

  submitBookingReturn(booking:any){
    return this.http.post(environment.bookingApiV2,booking);
  }

  fetchData(query:any){
    return this.http.get(`${environment.bookingCheckPayApi}` +'?m='+ query ,httpOptions);
  }


  submitCheckPay(data:any,id){
    return this.http.post<any>(environment.bookingCheckPayApi +'?m='+ id,data,httpOptions);
  }

}
